import {
  ExternalLink,
  ExternalLinkContextProvider as Provider,
  ExternalLinkProps,
  ExternalLinkReplacements,
  useExternalLinkContext,
} from '@boxcryptor-web/ui';
import { usePageContext } from '../../node/context';
import { Language } from '../../node/language';
import { getReplacedExternalLink } from './link';
import { useLinkIdContext } from './LinkIdContext';

const helpPageReplacements: ExternalLinkReplacements = {
  '/help': { href: 'https://www.boxcryptor.com/help/overview', target: '_self' },
  '/help/about/': {
    href: 'https://www.boxcryptor.com/help/about/',
    target: '_self',
  },
  '/help/boxcryptor-account/': { href: 'https://boxcryptor.com/help/boxcryptor-account/', target: '_self' },
  '/help/faq-and-troubleshooting/': {
    href: 'https://www.boxcryptor.com/help/faq-and-troubleshooting/',
    target: '_self',
  },
  '/help/faq-and-troubleshooting/macos/': {
    href: 'https://boxcryptor.com/help/faq-and-troubleshooting/macos/',
    target: '_self',
  },
  '/help/ios/': {
    href: 'https://www.boxcryptor.com/help/ios/',
    target: '_self',
  },
  '/help/manage-cloud-providers-and-locations/windows/': {
    href: 'https://boxcryptor.com/help/manage-cloud-providers-and-locations/windows/',
    target: '_self',
  },
  '/help/overview': { href: 'https://www.boxcryptor.com/help/overview', target: '_self' },
  '/help/settings/ios/': { href: 'https://boxcryptor.com/help/settings/ios/', target: '_self' },
};

export function getExternalReplacements(lang: Language): ExternalLinkReplacements {
  return {
    '/sign-in': { href: 'https://www.boxcryptor.com/app', target: '_self' },
    '/sign-up': { href: 'https://www.boxcryptor.com/app/signup', target: '_self' },
    '/company-trial': { href: 'https://www.boxcryptor.com/app/signup/company', target: '_self' },
    '/app': { href: 'https://www.boxcryptor.com/app/', target: '_self' },
    '/app/sign-up': { href: 'https://www.boxcryptor.com/app/signup', target: '_self' },
    '/community': { href: 'https://boxcryptor.community', target: '_self' },
    '/youtube': { href: 'https://www.youtube.com/Boxcryptor', target: '_blank' },
    '/instagram': { href: 'https://www.instagram.com/boxcryptor/', target: '_blank' },
    '/twitter': {
      href: lang === 'de' ? 'https://twitter.com/boxcryptorDE' : 'https://twitter.com/boxcryptor',
      target: '_blank',
    },
    '/linkedin': { href: 'https://www.linkedin.com/company/boxcryptor', target: '_blank' },
    '/mastodon': { href: 'https://mastodon.social/@boxcryptor', target: '_blank' },
    '/whisply': { href: 'https://whisp.ly/', target: '_blank' },
    ...helpPageReplacements,
  };
}

const ExternalLinkComponent: React.FC<ExternalLinkProps> = (props) => {
  const { idPrefix } = useLinkIdContext();
  const id = idPrefix && props.trackingId ? `${idPrefix}:${props.trackingId}` : undefined;
  const { getReplacedExternalLink } = useExternalLinkContext();
  const replacedLink = { ...getReplacedExternalLink(props), trackingId: undefined };
  return (
    <a target="_blank" {...replacedLink} className={props.className} rel="noreferrer" id={id}>
      {props.children}
    </a>
  );
};

export const ExternalLinkContextProvider: React.FC<{ baseUrl: string; children: React.ReactNode }> = ({ baseUrl, children }) => {
  const { lang } = usePageContext();
  return (
    <Provider
      value={{
        externalLinkComponent: (props) => <ExternalLinkComponent {...props} />,
        getReplacedExternalLink: (link: ExternalLink) =>
          getReplacedExternalLink({ link, replacements: getExternalReplacements(lang), baseUrl }),
      }}
    >
      {children}
    </Provider>
  );
};
